import Page from "webPage/Page";
import $ from "jquery";
import Ajax from "base/Ajax";

Page.register('/case-studies', () => {
    let loadRequest;

    $("body").on("click", ".js-read-more", function () {

        let $modal = $(".js-read-more-modal");
        let id = $(this).parents(".what-we-do").attr("data-id");

        $("body").addClass("modal-active");
        $modal.addClass("modal--active");
        if ($modal.attr("data-id") === id) {
            return false;
        }

        if (loadRequest) loadRequest.abort();

        let $modalContent = $modal.find(".js-modal-content");

        $modalContent.html(
            eotwJSXFactory('span', {class: "article-list__loader article-list__loader--show"}, [
                eotwJSXFactory('span', {class: "article-list__loader-icon"})
            ])
        );
        $modal.attr("data-id", id);
        Ajax.get("content", "dc48bd5b513eb317/posts/" + id, {}, Ajax.WEBSITE).then((data) => {
            $modalContent.html([
                eotwJSXFactory('div', {class: "modal__header modal__header--grey"}, [
                    eotwJSXFactory('h4', {unsafeHtml: data.activeRevision.values.title})
                ]),
                eotwJSXFactory('div', {class: "modal__body", unsafeHtml: data.activeRevision.values['long-content']})
            ]);
        }).catch((e) => {
            console.error(e);
            $modalContent.html("Couldn't load the content");
        });
        return false;
    });

});
